"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteList = NoteList;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/NoteList/index.tsx
// Figma: 注意事項セクションの本文カード。
// ガラス面ではなく background.neutral.default のベタ面 (radius.md / p16)。
//
// items には改行区切りの 1 本の文字列 (v1 の preSale.note 相当) も
// 配列も渡せる。文字列の場合は改行で分割し、空行は捨てる。
//
// bullet を指定したときだけ「記号セル + 本文セル」の 2 カラムで組み、
// 本文だけを折り返す (Figma: List = ※ セル + 本文セル)。
// 既定では記号を付けない。preSale.note のように出稿者が自由入力する
// テキストは既に「※」等を含んでいることがあり、自動で付けると
// 「※ ※〜」と二重になるため。
//
// 色は theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
function NoteList(_a) {
    var items = _a.items, bullet = _a.bullet;
    var p = (0, theme_1.useV2Palette)();
    var lines = (typeof items === 'string' ? items.split('\n') : items)
        .map(function (line) { return line.trim(); })
        .filter(function (line) { return line.length > 0; });
    if (lines.length === 0)
        return null;
    var textSx = __assign(__assign({}, tokens_1.textStyles.body), { lineHeight: "".concat(tokens_1.lineHeight.sm, "px"), color: p.foreground.neutral.primary });
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            boxSizing: 'border-box',
            width: '100%',
            p: "".concat(tokens_1.spacing.md, "px"),
            borderRadius: "".concat(tokens_1.radius.md, "px"),
            backgroundColor: p.background.neutral.default,
        }, children: lines.map(function (line, i) {
            return bullet ? ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "flex-start", spacing: "".concat(tokens_1.spacing.xs, "px"), sx: { width: '100%' }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", sx: __assign({ flexShrink: 0 }, textSx), children: bullet }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", sx: __assign(__assign({ flex: '1 1 0%', minWidth: 0 }, textSx), { wordBreak: 'break-all' }), children: line })] }, i)) : ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({}, textSx), { wordBreak: 'break-all' }), children: line }, i));
        }) }));
}
